<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<h1 class="center">Good Night, Mr. James</h1>
<h2 class="center" style="margin-top:10px;">And Other Stories</h2>
<h2 class="center" style="margin-top:40px;">The Complete Short Fiction of Clifford D. Simak, Volume Eight</h2>
<h3 class="center" style="margin-top:20px;">Introduction by David W. Wixon</h3>
<p class="center" style="margin-top:80px;"><img alt="image" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1.vue?14138756